module.exports = __webpack_public_path__ + "img/carousel-03.d4661bce.png";